module.exports = {
	'bootstrap': require('./lib/bootstrap-variables.json')
}
